module.exports = __webpack_public_path__ + "static/media/单电机双足机器人.547a40ba.png";